import { useState, useEffect } from "react";
import AirMilestoneManage from "./air-milestone-manage";
import OceanMilestoneManage from "./ocean-milestone-manage";
import { axiosInstance } from "../../utility/apiInstance";
import { GROUND_STAFF, SelectOption } from "./type";
import ServiceTypeToggle from "../../components/shared/ServiceTypeToggle";
import "../../components/CommunicationTemplete/CommunicationTemplate.css"; 

export default function MilestoneManage() {
  const [groundStaffs, setGroundStaffs] = useState<GROUND_STAFF[]>([]);
  const [isGroundStaffsLoaded, setIsGroundStaffsLoaded] = useState(false);
  const [activeTab, setActiveTab] = useState<"air" | "ocean">("air");

  const getGroundStaffs = async () => {
    try {
      setIsGroundStaffsLoaded(false);
      const { data } = await axiosInstance.get("/api/v1/customers-auth/customer-staffs");
      setGroundStaffs(data?.data || []);
    } catch (error) {
      setGroundStaffs([]);
    } finally {
      setIsGroundStaffsLoaded(true);
    }
  };

  const groundStaffOptions: SelectOption[] = groundStaffs.map((gs) => ({
    label: gs.name,
    value: gs._id,
  }));

  useEffect(() => {
    getGroundStaffs();
  }, []);

  return (
    <div>
      <div className="ctpl-page-header">
        <div className="ctpl-title-col">
          <h1>Milestone Management</h1>
          <p>Configure milestone mapping and assignments for each shipment mode.</p>
        </div>
        <ServiceTypeToggle onTypeChange={setActiveTab} activeTab={activeTab} width="320px" />
      </div>

      {activeTab === "air" ? (
        <AirMilestoneManage groundStaffOptions={groundStaffOptions} />
      ) : (
        <OceanMilestoneManage groundStaffOptions={groundStaffOptions} />
      )}
    </div>
  );
}